/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable unicorn/prefer-string-slice */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-useless-catch */
/* eslint-disable lingui/text-restrictions */
/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable lingui/no-unlocalized-strings */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable unicorn/prefer-add-event-listener */
import { io } from "socket.io-client";

import type { ChatCompletionOptions } from "@/server/agent/zhipu/zhipu.types";

import { SYSTEM_PROMPTS } from "./agent-prompt";

// 添加类型定义
type Experience = {
  id: string;
  company: string;
  position: string;
  summary: string;
};

type ExperienceItemData = {
  id: string;
  company?: string;
  position?: string;
  summary?: string;
  [key: string]: any;
};

type Project = {
  id: string;
  name: string;
  description?: string;
  summary?: string;
};

type ProjectItemData = {
  id: string;
  name?: string;
  description?: string;
  summary?: string;
  [key: string]: any;
};

export type SkillItem = {
  id: string;
  skills: string[];
};

type ZhipuResponse = {
  choices: {
    message: {
      content: string;
    };
  }[];
};

// 构建技能生成的提示词
export const generateSkillsPrompt = (
  experiences: { id: string; company?: string; position?: string; summary?: string }[],
  projects: { id: string; name?: string; description?: string; summary?: string }[],
): string => {
  // 准备API请求数据
  const apiPayload = {
    experiences: experiences.map((exp) => ({
      id: exp.id,
      company: exp.company || "",
      position: exp.position || "",
      summary: exp.summary || "",
    })),
    projects: projects.map((proj) => ({
      id: proj.id,
      name: proj.name || "",
      description: proj.description || "",
      summary: proj.summary || "",
    })),
  };

  // 使用提示词模板并插入经历数据
  return SYSTEM_PROMPTS.WEBSITE_SKILLS_GENERATOR.replace(
    "[经历数据将在此处提供]",
    JSON.stringify(apiPayload, null, 2),
  );
};

export const chatWithZhipu = async (options: ChatCompletionOptions) => {
  const response = await fetch("/api/agent/zhipu/chat", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(options),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const chatWithZhipuStream = async (
  options: ChatCompletionOptions,
  callbacks: {
    onMessage: (content: string) => void;
    onComplete: () => void;
    onError: (error: string) => void;
  },
) => {
  // 确保选项中设置了stream=true
  options.stream = true;

  // 创建唯一的会话ID，用于关联日志
  const sessionId = `stream_${Date.now()}`;

  // 记录流式片段的计数器
  let chunkCounter = 0;

  // 记录开始时间
  const startTime = Date.now();
  console.log(`[${sessionId}] 开始流式请求，时间: ${new Date().toISOString()}`);

  // 创建Socket连接，添加重连和超时配置
  const socket = io({
    path: "/api/socket.io",
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    timeout: 20_000,
  });

  // 连接成功时发送请求
  socket.on("connect", () => {
    console.log(
      `[${sessionId}] WebSocket连接成功，发送流式请求，时间: ${new Date().toISOString()}`,
    );
    socket.emit("chat_stream", options);
  });

  // 接收流式内容
  socket.on("chat_stream_content", (content: string) => {
    // 增加计数器
    chunkCounter++;

    // 计算接收时间
    const receiveTime = Date.now();
    const elapsedMs = receiveTime - startTime;

    // 记录详细日志
    console.log(`[${sessionId}] 接收流式内容片段 #${chunkCounter}:`, {
      时间: new Date().toISOString(),
      耗时: `${elapsedMs}ms`,
      内容长度: content.length,
      内容预览: content.length > 30 ? `${content.substring(0, 30)}...` : content,
      当前接收总片段数: chunkCounter,
    });

    // 确保接收到内容时立即回调
    callbacks.onMessage(content);
  });

  // 流式内容完成回调
  socket.on("chat_stream_done", () => {
    // 计算总耗时
    const totalTime = Date.now() - startTime;

    console.log(`[${sessionId}] 流式内容接收完成:`, {
      总片段数: chunkCounter,
      总耗时: `${totalTime}ms`,
      平均每片段耗时: chunkCounter > 0 ? `${Math.round(totalTime / chunkCounter)}ms` : "N/A",
      时间: new Date().toISOString(),
    });

    callbacks.onComplete();
    socket.disconnect();
  });

  // 错误处理
  socket.on("chat_stream_error", (error: string) => {
    console.error(`[${sessionId}] 流式请求错误:`, {
      错误: error,
      总耗时: `${Date.now() - startTime}ms`,
      已接收片段数: chunkCounter,
    });
    callbacks.onError(error);
    socket.disconnect();
  });

  // 断开连接处理
  socket.on("disconnect", () => {
    console.log(`[${sessionId}] WebSocket连接已断开，时间: ${new Date().toISOString()}`);
  });

  // 连接错误处理
  socket.on("connect_error", (error: Error) => {
    console.error(`[${sessionId}] WebSocket连接错误:`, {
      错误消息: error.message,
      时间: new Date().toISOString(),
    });
    callbacks.onError(`连接错误: ${error.message}`);
  });

  // 返回断开连接的函数
  return () => {
    socket.disconnect();
  };
};

export const buildResumeWithZhipu = async (content: string) => {
  // Fetch model configuration
  let modelConfig;
  try {
    const configResponse = await fetch("/api/agent/zhipu/config");
    modelConfig = configResponse.ok
      ? await configResponse.json()
      : {
          model: "google/gemini-2.0-flash-001",
          temperature: 0.7,
          top_p: 0.7,
          max_tokens: 4096,
        };
  } catch {
    modelConfig = {
      model: "google/gemini-2.0-flash-001",
      temperature: 0.7,
      top_p: 0.7,
      max_tokens: 4096,
    };
  }

  const options: ChatCompletionOptions = {
    model: modelConfig.model,
    messages: [
      { role: "system", content: SYSTEM_PROMPTS.RESUME_BUILDER },
      { role: "user", content },
    ],
    temperature: modelConfig.temperature,
    top_p: modelConfig.top_p,
    max_tokens: modelConfig.max_tokens,
    stream: false,
  };

  try {
    const response = await fetch("/api/agent/zhipu/chat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    const data = await response.json();

    try {
      const resumeData = JSON.parse(data.choices[0].message.content);
      return resumeData;
    } catch {
      throw new Error("Invalid resume data format");
    }
  } catch (error) {
    throw error;
  }
};

export const generateSkillsWithZhipu = async (
  experiences: (Experience | ExperienceItemData)[],
  projects: (Project | ProjectItemData)[],
): Promise<{ experiences: SkillItem[]; projects: SkillItem[] }> => {
  try {
    // 构建API请求数据
    const apiPayload = {
      model: "google/gemini-2.0-flash-001",
      messages: [
        {
          role: "user",
          content: generateSkillsPrompt(experiences, projects),
        },
      ],
      temperature: 0.1,
      max_tokens: 4000,
    };

    console.log("Calling Zhipu API with payload:", JSON.stringify(apiPayload, null, 2));

    // 使用代理API发送请求，而不是直接调用智谱API
    // 这样可以避免在浏览器端暴露API密钥
    const response = await fetch("/api/agent/zhipu/chat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(apiPayload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    const zhipuResponse = await response.json();
    const content = zhipuResponse.choices[0]?.message?.content || "";
    console.log("Zhipu API raw response:", content);

    // 尝试多种方法提取和解析JSON内容
    // 方法1: 尝试解析整个内容
    try {
      const parsedData = JSON.parse(content);
      console.log("Successfully parsed full content as JSON");
      return parsedData;
    } catch {
      console.log("Failed to parse full content as JSON, trying alternative methods");
    }

    // 方法2: 尝试提取markdown代码块中的JSON
    const markdownJsonRegex = /```(?:json)?\s*([\S\s]*?)\s*```/;
    const markdownMatch = markdownJsonRegex.exec(content);
    if (markdownMatch && markdownMatch[1]) {
      try {
        const parsedData = JSON.parse(markdownMatch[1]);
        console.log("Successfully parsed JSON from markdown code block");
        return parsedData;
      } catch {
        console.log("Failed to parse JSON from markdown code block");
      }
    }

    // 方法3: 尝试提取第一个花括号到最后一个花括号之间的内容
    const firstBrace = content.indexOf("{");
    const lastBrace = content.lastIndexOf("}");
    if (firstBrace !== -1 && lastBrace !== -1 && firstBrace < lastBrace) {
      const jsonStr = content.substring(firstBrace, lastBrace + 1);
      try {
        const parsedData = JSON.parse(jsonStr);
        console.log("Successfully parsed JSON using brace extraction");
        return parsedData;
      } catch {
        console.log("Failed to parse JSON using brace extraction");
      }
    }

    // 方法4: 尝试修复可能的JSON字符串
    const cleanJson = (str: string): string => {
      // 删除行首的无关字符（如>、空格等）
      let cleaned = str.replace(/^[\s>]+/gm, "");
      // 替换掉可能导致问题的Unicode字符
      cleaned = cleaned.replace(/[\u201C\u201D]/g, '"');
      // 确保属性名和值之间的冒号周围有合适的空格
      cleaned = cleaned.replace(/(\S):/g, "$1: ");
      // 尝试修复缺少的引号
      cleaned = cleaned.replace(/([,{]\s*)(\w+)(\s*:)/g, '$1"$2"$3');
      return cleaned;
    };

    // 尝试所有可能的提取和清理组合
    const possibleJsons = [content, content.substring(firstBrace, lastBrace + 1)];

    if (markdownMatch && markdownMatch[1]) {
      possibleJsons.push(markdownMatch[1]);
    }

    for (const json of possibleJsons) {
      const cleanedJson = cleanJson(json);
      try {
        const parsedData = JSON.parse(cleanedJson);
        console.log("Successfully parsed JSON after cleaning");
        return parsedData;
      } catch {
        // 继续尝试下一个可能的JSON
      }
    }

    // 如果所有解析尝试都失败，返回一个默认结构
    console.error("All JSON parsing attempts failed, returning default structure");
    return {
      experiences: experiences.map((exp) => ({ id: exp.id, skills: [] })),
      projects: projects.map((proj) => ({ id: proj.id, skills: [] })),
    };
  } catch (error) {
    console.error("Error in generateSkillsWithZhipu:", error);
    // 返回默认结构
    return {
      experiences: experiences.map((exp) => ({ id: exp.id, skills: [] })),
      projects: projects.map((proj) => ({ id: proj.id, skills: [] })),
    };
  }
};

// 辅助函数：从经验/项目数据中提取ID
const extractId = (item: Experience | ExperienceItemData | Project | ProjectItemData): string => {
  return "id" in item ? item.id : "";
};

export const uploadFile = async (
  file: File,
  onProgress?: (progress: number) => void,
): Promise<{ fileId: string }> => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await fetch("/api/agent/zhipu/files/upload", {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || response.statusText);
    }

    const data = await response.json();

    // 如果响应包含 id，说明上传成功
    if (data.id) {
      return { fileId: data.id };
    }

    throw new Error("上传失败");
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error("上传失败");
  }
};

export const getFileContent = async (fileId: string): Promise<{ content: string }> => {
  try {
    const response = await fetch(`/api/agent/zhipu/files/${fileId}/content`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "获取文件内容失败");
    }

    return response.json();
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : "获取文件内容失败");
  }
};

export const deleteFile = async (fileId: string): Promise<{ deleted: boolean }> => {
  try {
    const response = await fetch(`/api/agent/zhipu/files/${fileId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "删除文件失败");
    }

    return response.json();
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : "删除文件失败");
  }
};
